import { inject, Service, signal } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { distinctUntilChanged, filter, map, Subject } from "rxjs";

import { AdaaHelper } from "../../core/utils";
import type { BaseButtonUiOption } from "../components/general/float-action/types";

export type FloatActionType = BaseButtonUiOption & {
  key: string;
  data: unknown;
};

@Service()
export class FloatActionService {
  actions = signal<FloatActionType[]>([]);

  readonly #untilDestroyed = AdaaHelper.untilDestroyed();

  readonly notesSaved = new Subject<void>();
  readonly onClick = new Subject<{ action: FloatActionType["key"]; data: FloatActionType["data"] }>();

  readonly notesSaved$ = this.notesSaved.asObservable();
  readonly onClick$ = this.onClick.asObservable();

  constructor() {
    const router = inject(Router);

    router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        map((event) => event.urlAfterRedirects.split("?")[0]),
        distinctUntilChanged(),
        this.#untilDestroyed()
      )
      .subscribe(() => this.reset());

    this.reset();
  }

  public add(action: FloatActionType) {
    this.actions.update((actions) => {
      if (!actions.find((a) => a.key === action.key)) {
        return [...actions, action];
      }
      return actions;
    });
  }

  public clear() {
    this.actions.set([]);
  }

  public reset() {
    this.actions.set([
      {
        key: "helpdesk",
        text: "plusbutton.newhelpdeskticket",
        icon: {
          type: "adaa",
          value: "adaa-icon-new",
        },
        data: {
          url: "/helpdesk/create",
        },
      },
    ]);
  }
}
